import { BUSCAR_PESSOA_REMETENTE, SELECIONAR_PESSOA_REMETENTE } from '../../actions/types'

const initialState = undefined

export default function reducerPessoa (state = {}, action = initialState) {
  switch (action.type) {
    case BUSCAR_PESSOA_REMETENTE: {
      return action.payload.data;
    }

    case SELECIONAR_PESSOA_REMETENTE: {
      return action.payload;
    }

    default: {
      return state
    }
  }
}
